/* eslint-disable jsx-a11y/heading-has-content */
import React, { useRef } from "react";
import emailjs from "@emailjs/browser";
import Navbar from "../Navbar/index";
import "./contact.css";
import { Form } from "./Form/Form";
import { IoIosSend } from "react-icons/io";
import { BsFillPersonFill } from "react-icons/bs";
import { BiLoaderAlt } from "react-icons/bi";
import { MdEmail } from "react-icons/md";
import { RiMessage3Fill } from "react-icons/ri";
import Buttons from "../Buttons/index";
import SectionTitle from "../SectionTitle";
import { motion } from "framer-motion";
import ContactInfo from "./ContactInfo/ContactInfo";

const Contact = () => {
  const desc =
    "I’M ALWAYS OPEN TO DISCUSSING PRODUCT DESIGN WORK OR PARTNERSHIPS.";
  const formGroup = [
    {
      id: 1,
      type: "text",
      Iname: "user_name",
      Iid: "name",
      IplaceH: "YOUR NAME",
      Inicon: <BsFillPersonFill />,
    },
    {
      id: 2,
      type: "email",
      Iname: "user_email",
      Iid: "email",
      IplaceH: "YOUR EMAIL",
      Inicon: <RiMessage3Fill />,
    },
  ];
  const variants = {
    hidden: { opacity: 0, x: -1500, y: 0 },
    enter: { opacity: 1, x: 0, y: 0 },
    exit: { opacity: 1, x: 0, y: -200 },
  };
  // form
  const form = useRef();
  const getHref = useRef();
  const msgtext = useRef();
  const addloader = useRef();
  const sendEmail = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_9gs41ck",
        "template_diwt8gm",
        form.current,
        "lvxKxuc4I-9m-D_SM"
      )
      .then(
        (result) => {
          msgtext.current.innerHTML = "Message Has Been Sent Successfully.";
          setTimeout(() => {
            msgtext.current.innerHTML = "";
          }, 3000);
          addloader.current.classList.remove("animated_load");
        },
        (error) => {
          msgtext.current.innerHTML =
            "There is Something Wrong!!! Message Did Not Sent.";
          addloader.current.classList.remove("animated_load");
        }
      );
  };
  const handlebtn = () => {
    addloader.current.classList.add("animated_load");
    getHref.current.querySelector(".main_btn a").removeAttribute("href");
  };
  return (
    <motion.div
      variants={variants}
      initial="hidden"
      animate="enter"
      exit="exit"
      transition={{ type: "linear", duration: 0.5 }}
    >
      <section className="contact_area">
        <Navbar activeLi4={"activeLi"} />
        <div className="container">
          <SectionTitle sectitle={"GET"} clrTtle="IN TOUCH" secDesc={desc} />
          <div className="contact_contents">
            <div className="contact_left">
              <ContactInfo />
            </div>
            <div className="contact_right">
              <div className="desc">
                <p>
                  If you have any suggestion, project or even you want to say
                  Hello.. please fill out the form below and I will reply you
                  shortly.
                </p>
              </div>
              <form ref={form} onSubmit={sendEmail} className="contact_form">
                <div className="input_boxes">
                  {formGroup.map((formGroups) => (
                    <div className="form_group" key={formGroups.id}>
                      <Form
                        Itype={formGroups.type}
                        Iname={formGroups.Iname}
                        IplaceH={formGroups.IplaceH}
                        Iicon={formGroups.Inicon}
                        required
                      />
                    </div>
                  ))}
                </div>
                <div className="form_group text_area">
                  <textarea
                    name="message"
                    placeholder="YOUR MESSAGE"
                    id="message"
                    className="form_control"
                    required
                  ></textarea>
                  <span className="Formicon">
                    <MdEmail />
                  </span>
                </div>
                <div className="message_txt">
                  <h1 ref={msgtext}></h1>
                </div>
                <div className="section_btns">
                  <button type="submit" onClick={handlebtn} ref={getHref}>
                    <Buttons btnIcon={<IoIosSend />} btntext={"Send Message"} />
                    <div className="loader" ref={addloader}>
                      <span>
                        <BiLoaderAlt />
                      </span>
                    </div>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </motion.div>
  );
};

export default Contact;
